
import { Vue, Component, Prop } from 'vue-property-decorator';
import { SgkKamuCevap } from '@/plugins/uyap-plugin/uyap/SgkKamu';

@Component({})
export default class KamuAktifDetay extends Vue {
  @Prop() data!: SgkKamuCevap;

  get kamuBilgi() {
    return this.data.sorguSonucDVO;
  }

  // DEV-3354: UYAP kimlik alanını tckn yerine tck olarak döndürüyor; veri var/yok kararı
  // artık kimlik alanına değil hataKodu'na bakıyor (0 = kayıt bulundu, 995 = kayıt yok).
  get hasData() {
    return !!this.kamuBilgi && (this.kamuBilgi.hataKodu === 0 || this.kamuBilgi.hataKodu === 995);
  }

  getDurumColor(durumKapsami: string) {
    if (!durumKapsami) return 'grey';
    const durum = durumKapsami.toLowerCase().trim();
    if (durum.includes('aktif')) return 'success';
    if (durum.includes('pasif')) return 'error';
    return 'warning';
  }
}
